import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-province-of-employment-ofline',
  templateUrl: './province-of-employment-ofline.component.html',
  styleUrls: ['./province-of-employment-ofline.component.scss']
})
export class ProvinceOfEmploymentOflineComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
